<template>
  <v-card class="text-center py-2" style="height:100%">
    <h3 class="my-2" style="font-family:mplus-2c-light;">Liquitous Accountパスワードの再設定</h3>
    <!--画像-->
    <v-img src="../../assets/png/Liqlid_icon_logo.png" width="60%" class="my-6 mx-auto"></v-img>
    <!--Error-->
    <div class="text-center">
      <p v-if="errorAccountDisabled === true">アカウントが存在しません<br>管理者にお問い合わせください</p>
      <p v-if="errorNoAccount === true">アカウントが作成されていません<br><a href="/signup">ここをクリックしてアカウントを作成</a></p>
      <p v-if="errorEmailInValid === true">メールアドレスの形式が違います<br>もう一度正しく入力してください</p>
    </div>
    <!--入力フォーム-->
    <v-form class="px-12">
      <p class="">メールアドレス</p>
      <v-text-field
        v-model="email"
        :rules="[rules.mailrequired, rules.email]"
        placeholder="メールアドレスを入力"
        rounded
        outlined
      ></v-text-field>
    </v-form>

    <!--LoginBtn-->
    <!--TODO: 処理中にボタンを押せないようにする-->
    <v-btn
      large
      class="my-4 font-weight-bold rounded-pill white--text"
      @click="reseterr(),submit()"
      color="#008CFF"
      style="text-transform: none; font-family: mplus-2c-bold;"
      :disabled="!email"
    >  パスワードリセットメールを送る
    </v-btn>
    <div class="mt-2">
      <v-btn class="back" color="back" text @click="changeView('signin')">
        <span style="color:#008CFF">＜</span> &nbsp; &nbsp;戻る &nbsp; &nbsp;<span style="color:#008CFF">＞</span>
      </v-btn>
    </div>
    
  </v-card>
</template>

<script>
import firebase from 'firebase'
export default {
  data () {
    return {
      show1: false,
      email: '',
      rules: {
        required: value => !!value || 'メールアドレスを入力してください',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'メールアドレスの形式が違います'
        }
      },
      pwer: false,
      errorEmailInValid: false,
      errorAccountDisabled: false,
      errorNoAccount: false,
      aller: false
    }
  },
  methods: {
    submit: async function(){
      const res = await this.$store.dispatch('auth/resetPassword', this.email)
      if (res.success) {
        this.$emit('closeModal')
      } else {
        if (res.error.code === 'auth/user-not-found') {
          this.errorNoAccount = true
        } else if (res.error.code === 'auth/user-disabled') {
          this.errorAccountDisabled = true
        } else if (res.error.code === 'auth/invalid-email') {
          this.errorEmailInValid = true
        } else {
          this.aller = true
        }
      }
    },
    reseterr(){
      this.pwer = false,
      this.errorEmailInValid = false,
      this.errorAccountDisabled = false,
      this.errorNoAccount = false,
      this.aller = false
    },
    closeModal(){
      this.$emit('closeModal')
    },
    changeView(view){
      this.$emit('changeView', view)
    },
  },
  mounted(){
    this.reseterr()
  }
}
</script>